import { useState, Suspense } from 'react'
import { Form, useActionData, useRouteLoaderData, useParams, useNavigation, Link, Await } from 'react-router-dom';
import AdminMatchesForm from '../../components/admin/AdminMatchesForm.jsx'
import AdminMatchesShow from '../../components/admin/AdminMatchesShow.jsx'
import { ListTeams } from '../../repo/TeamsRepo.js'
import { GetTournament } from '../../repo/TournamentsRepo.js'
import { CreateMatch } from '../../repo/MatchesRepo.js'

export default function MatchNewPage() {
  const {tournamentId} = useParams()
  const response = useActionData()
  const matchRelations = useRouteLoaderData('admin-match-new')
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'
  const [tournament, setTournament] = useState(matchRelations.tournament)

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminMatchesShow tournament={tournament} match={response.data} status="created"/>
      ) : (
        <>
          <h1>Create New Match: { tournament ? tournament.name + ' ' + tournament.edition : '' } </h1>
          <div id="match-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="POST" className="space-y-4 md:space-y-6 mt-4">
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={matchRelations}>
                  {(loadedMatchRelations) => <AdminMatchesForm teams={loadedMatchRelations.teams.data} tournament={loadedMatchRelations.tournament} errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>}
                </Await>
              </Suspense>
            </Form>
          </div>

          <div id="matches" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournamentId}/matches`}>Back to Matches</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const matchData = {
    team_a_id: data.get('team_a_id'),
    team_b_id: data.get('team_b_id'),
    tournament_id: data.get('tournament_id'),
    starts_at: data.get('starts_at'),
    group_name: data.get('group_name'),
    phase: data.get('phase'),
    third_party_label: data.get('third_party_label'),
    third_party_id: data.get('third_party_id'),
    is_demo: validateDemo(document.getElementById('is_demo'))
  }

  return CreateMatch(matchData)
}

function validateDemo(isDemoObject) {
  try {
    return (isDemoObject.checked ? "1" : "0")
  } catch (error) {
    return "0"
  }
}


export async function loader({ params, request }) {
  return {
    teams: await ListTeams(1, { skip_pagination: 1 }),
    tournament: await GetTournament(params.tournamentId),
  }
}
